import { lazy } from "react";
import { ssrGetInitData } from "./getInitData";
import { getHeadTemplate } from "./getHeadTemplate";
import { ssrGetPageTemplate } from "./ssrGetPageTemplate";

const TeamSsrPage = lazy(() => import("./teamSsr"));

export const teamPageSsrProps = {
    ssrEnabled: true,
    ssrComponent: (ssrProps: any) => <TeamSsrPage {...ssrProps} />,
    ssrGetHeadTemplate: getHeadTemplate,
    ssrGetInitData,
    ssrGetPageTemplate,
    ssrOptions: {},
    notFoundComponent: (ssrProps: any) => <TeamSsrPage {...ssrProps} />,
}

export const teamPageSsrEnabledProps = {
    ...teamPageSsrProps,
    ssrEnabled: true,
}
import { lazy } from "react";
import { ssrGetInitData } from "./getInitData";
import { getHeadTemplate } from "./getHeadTemplate";
import { ssrGetPageTemplate } from "./ssrGetPageTemplate";

const TeamSsrPage = lazy(() => import("./teamSsr"));

export const teamPageSsrProps = {
    ssrEnabled: true,
    ssrComponent: (ssrProps: any) => <TeamSsrPage {...ssrProps} />,
    ssrGetHeadTemplate: getHeadTemplate,
    ssrGetInitData,
    ssrGetPageTemplate,
    ssrOptions: {},
    notFoundComponent: (ssrProps: any) => <TeamSsrPage {...ssrProps} />,
}

export const teamPageSsrEnabledProps = {
    ...teamPageSsrProps,
    ssrEnabled: true,
}
